import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getNewsList, removeNews } from "../../actions/NewsActions";
import aerialImg from "../../assets/aerial.png";
import logoImg from "../../assets/cdl-logo.png";
import "../../styles/Home.css";

function Home() {
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.auth);
  const { newsList, isLoading, error } = useSelector((state) => state.news);

  useEffect(() => {
    dispatch(getNewsList());
  }, [dispatch]);

  const handleDelete = (slug) => {
    if (
      window.confirm(
        `Are you sure you want to delete "${slug}"? This cannot be undone.`,
      )
    ) {
      dispatch(removeNews(slug));
    }
  };

  return (
    <div className="dashboard" style={{ backgroundImage: `url(${aerialImg})` }}>
      <div className="dashboard-hero">
        <div className="hero-content">
          <img src={logoImg} alt="Colombo Dockyard PLC" className="hero-logo" />
          <h1>CDL News Admin Panel</h1>
          <p>
            Manage and publish news articles for the Colombo Dockyard website.
          </p>
          {isLoggedIn && (
            <div className="hero-actions">
              <Link to="/admin/create" className="dashboard-cta">
                + Create New Article
              </Link>
              <Link to="/register" className="dashboard-cta secondary">
                + Add Admin User
              </Link>
            </div>
          )}
        </div>
      </div>

      <div className="dashboard-cards">
        <div className="dash-card">
          <div className="dash-card-icon">📝</div>
          <h3>Write</h3>
          <p>Compose news articles with rich text, images, and formatting.</p>
        </div>
        <div className="dash-card">
          <div className="dash-card-icon">🖼️</div>
          <h3>Media</h3>
          <p>Upload and arrange images including side-by-side layouts.</p>
        </div>
        <div className="dash-card">
          <div className="dash-card-icon">🚀</div>
          <h3>Publish</h3>
          <p>Instantly push articles live to the CDL website.</p>
        </div>
      </div>

      {isLoggedIn && (
        <div className="news-management">
          <h2>Published Articles</h2>
          {isLoading && <p className="news-loading">Loading...</p>}
          {error && <p className="news-error">{error}</p>}
          {!isLoading && newsList.length === 0 && (
            <p className="news-empty">No articles published yet.</p>
          )}
          <div className="news-table-wrapper">
            {newsList.length > 0 && (
              <table className="news-table">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Slug</th>
                    <th>Date</th>
                    <th>Created By</th>
                    <th>Updated By</th>
                    <th>Last Updated</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {newsList.map((article) => (
                    <tr key={article.Slug}>
                      <td>{article.Title}</td>
                      <td>
                        <code>{article.Slug}</code>
                      </td>
                      <td>{article.Date}</td>
                      <td>{article.CreatedBy ? article.CreatedBy.split('@')[0] : '-'}</td>
                      <td>{article.UpdatedBy ? article.UpdatedBy.split('@')[0] : '-'}</td>
                      <td>{article.UpdatedAt ? new Date(article.UpdatedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : '-'}</td>
                      <td className="news-actions">
                        <Link
                          to={`/admin/edit/${article.Slug}`}
                          className="btn-edit"
                        >
                          Edit  
                        </Link>
                        <button
                          onClick={() => handleDelete(article.Slug)}
                          className="btn-delete"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Home;
